import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2e072b8a = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _3259a6a1 = () => interopDefault(import('../../../pages/book-a-demo/index.vue' /* webpackChunkName: "pages/book-a-demo/index" */))
const _31d1d1ce = () => interopDefault(import('../../../pages/downloads/index.vue' /* webpackChunkName: "pages/downloads/index" */))
const _9fc96206 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _ddf1c0b6 = () => interopDefault(import('../../../pages/impressum/index.vue' /* webpackChunkName: "pages/impressum/index" */))
const _7a0e9997 = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _3d16f0f4 = () => interopDefault(import('../../../pages/pricing/index.vue' /* webpackChunkName: "pages/pricing/index" */))
const _20b359e6 = () => interopDefault(import('./prismic/pages/preview.vue' /* webpackChunkName: "" */))
const _8d7221fe = () => interopDefault(import('../../../pages/ref/index.vue' /* webpackChunkName: "pages/ref/index" */))
const _001ea26a = () => interopDefault(import('../../../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _28f4a718 = () => interopDefault(import('../../../pages/slice-simulator.vue' /* webpackChunkName: "pages/slice-simulator" */))
const _22ab939d = () => interopDefault(import('../../../pages/pricing/storage.vue' /* webpackChunkName: "pages/pricing/storage" */))
const _69c8313c = () => interopDefault(import('../../../pages/register/success.vue' /* webpackChunkName: "pages/register/success" */))
const _1332e5b6 = () => interopDefault(import('../../../pages/pricing/success.vue' /* webpackChunkName: "pages/pricing/success" */))
const _2c508a42 = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _98713638 = () => interopDefault(import('../../../pages/lp/_slug.vue' /* webpackChunkName: "pages/lp/_slug" */))
const _4c4f6680 = () => interopDefault(import('../../../pages/funktion/_slug.vue' /* webpackChunkName: "pages/funktion/_slug" */))
const _1269dac2 = () => interopDefault(import('../../../pages/sports/_slug.vue' /* webpackChunkName: "pages/sports/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog",
    component: _2e072b8a,
    name: "blog___de"
  }, {
    path: "/demo-buchen",
    component: _3259a6a1,
    name: "book-a-demo___de"
  }, {
    path: "/downloads",
    component: _31d1d1ce,
    name: "downloads___de"
  }, {
    path: "/en",
    component: _9fc96206,
    name: "index___en"
  }, {
    path: "/impressum",
    component: _ddf1c0b6,
    name: "impressum___de"
  }, {
    path: "/login",
    component: _7a0e9997,
    name: "login___de"
  }, {
    path: "/preise",
    component: _3d16f0f4,
    name: "pricing___de"
  }, {
    path: "/preview",
    component: _20b359e6,
    name: "prismic-preview___de"
  }, {
    path: "/ref",
    component: _8d7221fe,
    name: "ref___de"
  }, {
    path: "/register",
    component: _001ea26a,
    name: "register___de"
  }, {
    path: "/slice-simulator",
    component: _28f4a718,
    name: "slice-simulator___de"
  }, {
    path: "/en/blog",
    component: _2e072b8a,
    name: "blog___en"
  }, {
    path: "/en/book-a-demo",
    component: _3259a6a1,
    name: "book-a-demo___en"
  }, {
    path: "/en/downloads",
    component: _31d1d1ce,
    name: "downloads___en"
  }, {
    path: "/en/imprint",
    component: _ddf1c0b6,
    name: "impressum___en"
  }, {
    path: "/en/login",
    component: _7a0e9997,
    name: "login___en"
  }, {
    path: "/en/preview",
    component: _20b359e6,
    name: "prismic-preview___en"
  }, {
    path: "/en/pricing",
    component: _3d16f0f4,
    name: "pricing___en"
  }, {
    path: "/en/ref",
    component: _8d7221fe,
    name: "ref___en"
  }, {
    path: "/en/register",
    component: _001ea26a,
    name: "register___en"
  }, {
    path: "/en/slice-simulator",
    component: _28f4a718,
    name: "slice-simulator___en"
  }, {
    path: "/preise/speicher",
    component: _22ab939d,
    name: "pricing-storage___de"
  }, {
    path: "/register/success",
    component: _69c8313c,
    name: "register-success___de"
  }, {
    path: "/en/pricing/storage",
    component: _22ab939d,
    name: "pricing-storage___en"
  }, {
    path: "/en/register/success",
    component: _69c8313c,
    name: "register-success___en"
  }, {
    path: "/preise/checkout/success",
    component: _1332e5b6,
    name: "pricing-success___de"
  }, {
    path: "/en/pricing/checkout/success",
    component: _1332e5b6,
    name: "pricing-success___en"
  }, {
    path: "/",
    component: _9fc96206,
    name: "index___de"
  }, {
    path: "/en/blog/:slug",
    component: _2c508a42,
    name: "blog-slug___en"
  }, {
    path: "/en/lp/:slug?",
    component: _98713638,
    name: "lp-slug___en"
  }, {
    path: "/en/role/:slug",
    component: _4c4f6680,
    name: "funktion-slug___en"
  }, {
    path: "/en/sports/:slug",
    component: _1269dac2,
    name: "sports-slug___en"
  }, {
    path: "/blog/:slug",
    component: _2c508a42,
    name: "blog-slug___de"
  }, {
    path: "/funktion/:slug",
    component: _4c4f6680,
    name: "funktion-slug___de"
  }, {
    path: "/lp/:slug?",
    component: _98713638,
    name: "lp-slug___de"
  }, {
    path: "/sport/:slug",
    component: _1269dac2,
    name: "sports-slug___de"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
